// extracted by mini-css-extract-plugin
export default {"result":"CheckResult_result__KMH7m"};